/**
 * @generated SignedSource<<4009fe6b1ba2fcb46b7c392d5f0a6f2b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articleRenderArticle$data = {
  readonly __typename: string;
  readonly entityId: string;
  readonly sponsorType?: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"actionWidgetContent" | "articleAdditionalInfoBoxArticleContent" | "articleAuthorBlockArticle" | "articleAuthorDetailsContent" | "articleBaseAdvertisingInfoArticle" | "articleBeforeYouGoWidget" | "articleCommentsTriggerArticle" | "articleCorrectionsWidgetArticle" | "articleDateContent" | "articleImageGalleryContent" | "articleLeadingArticle" | "articleMoreOnThisListArticle" | "articlePianoPaywallContent" | "articlePrintHeadlineMessageArticle" | "articleReadingTimeContent" | "articleRecirculationWidgetArticle" | "articleRelatedTopicsContent" | "articleSectionsContent" | "articleSeriesArticle" | "articleShareWidgetArticle" | "articleSpeechInlineWidgetArticle" | "articleSpeechPlayerPortalArticle" | "articleSponsorContent" | "articleTopicContent" | "articleTopicFollowWidgetArticle" | "articleTopicWidgetArticle" | "articleTopicsContent" | "articleVocabBoxArticle" | "authorAvatarsArticle" | "authorNamesArticle" | "authorShortBioArticle" | "contentActionBarContent" | "contentBodyContent" | "contentHeadlineContent" | "contentHeadlineTagContent" | "contentLiveTagContent" | "contentReadMoreButtonContent" | "contentSchemaRenderContent" | "contentSubHeadlineContent" | "contentSummaryContent" | "genericArticleContent" | "globalCheckerContent" | "helpersCheckArticleIsInSectionsArticle" | "helpersCheckArticleRenderTypeArticle" | "helpersCheckIsVideoContent" | "helpersGetArticleTypeArticle" | "helpersIsPlusInlinePaywall" | "infographicArticleArticle" | "liveArticleArticle" | "morningStudioArticleContent" | "newsletterArticleArticle" | "pianoIntegrationArticle" | "plusColumnsArticleContent" | "plusGenericArticleContent" | "postMagazineArticleContent" | "seriesArticleArticle" | "styleArticleContent" | "videoArticleContent">;
  readonly " $fragmentType": "articleRenderArticle";
};
export type articleRenderArticle$key = {
  readonly " $data"?: articleRenderArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articleRenderArticle">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sponsorType",
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
},
v3 = [
  (v1/*: any*/)
],
v4 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SectionSegmentV2",
    "kind": "LinkedField",
    "name": "sectionsV2",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "value",
        "plural": true,
        "selections": [
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v3/*: any*/),
            "type": "VideoSection",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v6 = {
  "kind": "InlineDataFragmentSpread",
  "name": "helpersCheckArticleIsInSectionsArticle",
  "selections": (v5/*: any*/),
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v7 = {
  "kind": "InlineDataFragmentSpread",
  "name": "helpersCheckIsPlusArticle",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PaywallType",
          "kind": "LinkedField",
          "name": "paywallTypes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityUuid",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Article",
      "abstractKey": null
    }
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v8 = {
  "kind": "InlineDataFragmentSpread",
  "name": "helpersCheckIsStyleArticle",
  "selections": (v5/*: any*/),
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v9 = {
  "kind": "InlineDataFragmentSpread",
  "name": "helpersGetArticleTypeArticle",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ArticleTypeSegment",
          "kind": "LinkedField",
          "name": "types",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ArticleType",
              "kind": "LinkedField",
              "name": "value",
              "plural": true,
              "selections": (v3/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "Article",
      "abstractKey": null
    }
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
},
v10 = {
  "kind": "InlineDataFragmentSpread",
  "name": "helpersCheckIsVideoContent",
  "selections": [
    (v0/*: any*/)
  ],
  "args": null,
  "argumentDefinitions": ([]/*: any*/)
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": "PARAGRAPH",
      "kind": "LocalArgument",
      "name": "bodyType"
    },
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "customContents"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "articleRenderArticle",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "actionWidgetContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleAdditionalInfoBoxArticleContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleAuthorBlockArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleAuthorDetailsContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleBaseAdvertisingInfoArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleBeforeYouGoWidget"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleCommentsTriggerArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleCorrectionsWidgetArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleDateContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleImageGalleryContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleLeadingArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleMoreOnThisListArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articlePianoPaywallContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articlePrintHeadlineMessageArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleReadingTimeContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleRecirculationWidgetArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleRelatedTopicsContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleSectionsContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleSeriesArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleShareWidgetArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleSpeechInlineWidgetArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleSpeechPlayerPortalArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleSponsorContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleTopicContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleTopicFollowWidgetArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleTopicsContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleTopicWidgetArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "articleVocabBoxArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "authorAvatarsArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "authorNamesArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "authorShortBioArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentActionBarContent"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "bodyType",
          "variableName": "bodyType"
        },
        {
          "kind": "Variable",
          "name": "customContents",
          "variableName": "customContents"
        }
      ],
      "kind": "FragmentSpread",
      "name": "contentBodyContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentHeadlineContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentHeadlineTagContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentLiveTagContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentReadMoreButtonContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentSchemaRenderContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentSubHeadlineContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentSummaryContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "genericArticleContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "globalCheckerContent"
    },
    (v6/*: any*/),
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersCheckArticleRenderTypeArticle",
      "selections": [
        {
          "kind": "InlineDataFragmentSpread",
          "name": "helpersCheckCanShowInPlusPlatformContent",
          "selections": [
            (v0/*: any*/),
            (v6/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            {
              "kind": "InlineDataFragmentSpread",
              "name": "helpersUseContentSponsorContent",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Topic",
                  "kind": "LinkedField",
                  "name": "topics",
                  "plural": true,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Sponsor",
                      "kind": "LinkedField",
                      "name": "sponsor",
                      "plural": false,
                      "selections": [
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "sponsorTagSponsor"
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "name",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "type",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                (v2/*: any*/),
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "helpersCheckIsMainTopicContent",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Topic",
                      "kind": "LinkedField",
                      "name": "topics",
                      "plural": true,
                      "selections": (v3/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "args": null,
                  "argumentDefinitions": []
                }
              ],
              "args": null,
              "argumentDefinitions": []
            }
          ],
          "args": null,
          "argumentDefinitions": []
        },
        (v7/*: any*/),
        {
          "kind": "InlineDataFragmentSpread",
          "name": "helpersCheckIsPostMagazineArticle",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "SectionSegmentV2",
              "kind": "LinkedField",
              "name": "sectionsV2",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "value",
                  "plural": true,
                  "selections": [
                    (v4/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "args": null,
          "argumentDefinitions": []
        },
        (v8/*: any*/),
        (v10/*: any*/),
        (v9/*: any*/)
      ],
      "args": null,
      "argumentDefinitions": []
    },
    (v10/*: any*/),
    (v9/*: any*/),
    {
      "kind": "InlineDataFragmentSpread",
      "name": "helpersIsPlusInlinePaywall",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contentLock",
          "storageKey": null
        },
        (v9/*: any*/),
        (v7/*: any*/)
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "infographicArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "liveArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "morningStudioArticleContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "newsletterArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "pianoIntegrationArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "plusColumnsArticleContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "plusGenericArticleContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "postMagazineArticleContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "seriesArticleArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "styleArticleContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "videoArticleContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};
})();

(node as any).hash = "e3260b0c42a88044d75130a908c7f350";

export default node;
